export class FileUtil {
    static getBase64(file: File): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                const { result } = reader;
                if (!result) {
                    resolve('');
                    return;
                }
                if (typeof result === 'string') {
                    resolve(result.split(',')[1]);
                    return;
                }
                const bufferArray = new Uint8Array(result);
                resolve(btoa(String.fromCharCode(...bufferArray)));
            };
            reader.onerror = function () {
                reject(null);
            };
        });
    }

    static saveFile(data: Blob, filename: string): void {
        const invoiceFile = URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = invoiceFile;
        link.download = filename;
        link.click();
    }

    static saveTextFile(data: string, filename: string): void {
        const link = document.createElement('a');

        link.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(data));
        link.setAttribute('download', filename);
        link.click();
    }
}
